import { Clickable, Divider, IconButton, Row } from "globalComponents";
import React, { useEffect } from "react";
import styled from "styled-components";
import { getTheme } from "Theme";
import { faXmark, faCog, faRepeat } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";
import { clearUserData } from "globalResources/util";
const theme = getTheme();

const Drawer = styled.div`
  position: absolute;
  overflow-y: auto;
  z-index: 99;
  background: ${theme.PAGE_BACKGROUND};
  width: 280px;
  height: 100vh;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  opacity: ${(props) => (props.active ? 1 : 0)};
  transform: ${(props) =>
    props.active ? "translateX(0)" : "translateX(-100%)"};
  pointer-events: ${(props) => (props.active ? "auto" : "none")};
  transition:
    opacity 0.3s,
    transform 0.3s;
  box-shadow: 0 4px 16px ${theme.SHADOW};
  @media (max-width: 600px) {
    width: 90vw;
    padding: 16px 8vw 16px 8vw;
  }
`;

const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 20px;
  width: 100%;
`;

const ProfileSwitchSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10%;
  align-items: center;
  height: 90px;
  width: 100%;
`;
const ProfileSwitchButton = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
  :hover {
    background: ${theme.SECONDARY_COLOR};
    border-radius: 100px;
  }
`;
const CompanyName = styled.div`
  font-size: 2em;
  font-weight: 700;
`;
const Name = styled.div`
  font-size: 18px;
  font-weight: 500;
  text-align: center;
`;
const DrawerRoute = styled(Link)`
  display: flex;
  color: ${(props) => (props.current ? theme.TEXT : theme.TEXT)};
  background: ${(props) =>
    props.current ? theme.LIGHT_BLUE || "#50f381ff" : "transparent"};
  border: none;
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  padding: 10px 18px;
  margin: 0;
  width: 100%;
  justify-content: flex-end;
  transition:
    background 0.2s,
    color 0.2s;
  cursor: pointer;
  :hover {
    color: ${theme.MAIN_COLOR};
    background: ${theme.SECONDARY_COLOR};
  }
`;

const Route = styled(Link)`
  color: ${(props) => (props.current ? theme.MAIN_COLOR : theme.TEXT)};
  text-decoration: none;
  font-size: 16px;
  padding: 0 5px;
  font-weight: 520;

  :hover {
    color: ${theme.MAIN_COLOR};
  }
`;

const ActionRoute = styled.div`
  color: ${(props) => (props.current ? theme.MAIN_COLOR : theme.TEXT)};
  text-decoration: none;
  font-size: 16px;
  padding: 0 5px;
  font-weight: 520;

  :hover {
    color: ${theme.MAIN_COLOR};
  }
`;

const Dropdown = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  transition: all 0.2s;
  height: 100%;
  max-height: 200px;
  overflow-y: auto;
`;
const DropdownItem = styled.div`
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background: ${theme.LIGHT_BLUE || "#50f381ff"};
  }
`;

const NavigationDrawer = ({
  drawerOpen,
  setDrawerOpen,
  drawerRef,
  routes,
  setBug,
  accountName,
  userName,
  accounts,
  switchAccounts,
}) => {
  const [accountDropdownOpen, setAccountDropdownOpen] = React.useState(false);
  const history = useHistory();
  const ref = React.useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!drawerOpen) setAccountDropdownOpen(false);
  }, [drawerOpen]);

  return (
    <Drawer ref={drawerRef} active={drawerOpen}>
      <DrawerHeader>
        <Clickable onClick={() => setDrawerOpen(false)}>
          <IconButton icon={faXmark} />
        </Clickable>
        <Clickable
          style={{ marginLeft: "auto" }}
          onClick={() => {
            setDrawerOpen(false);
            history.push("/settings");
          }}
        >
          <IconButton icon={faCog} />
        </Clickable>
      </DrawerHeader>
      {accountDropdownOpen ? (
        <Dropdown>
          <Name style={{ fontWeight: "bold" }}>Your Accounts</Name>
          {accounts.map((account) => (
            <DropdownItem
              onClick={() =>
                switchAccounts(account.user._id, account.account._id)
              }
            >
              {account.account.name} (
              {account.user.accountType === "super"
                ? "Owner"
                : account.user.accountType}
              )
            </DropdownItem>
          ))}
        </Dropdown>
      ) : (
        <ProfileSwitchSection>
          <ProfileSwitchButton
            ref={ref}
            onClick={() => setAccountDropdownOpen(!accountDropdownOpen)}
          >
            <CompanyName>{accountName}</CompanyName>
            <Row style={{ gap: "8px" }}>
              <Name>{userName}</Name>{" "}
              <FontAwesomeIcon style={{ margin: "auto" }} icon={faRepeat} />
            </Row>
          </ProfileSwitchButton>
        </ProfileSwitchSection>
      )}
      <Divider />
      {routes.map((route, index) => (
        <DrawerRoute
          onClick={() => setDrawerOpen(false)}
          key={"drawer_route" + index}
          to={route.link}
          current={window.location.pathname === route.link ? "true" : undefined}
        >
          {route.name}
        </DrawerRoute>
      ))}
      <Divider />
      <Clickable
        style={{ marginRight: "auto" }}
        onClick={() => {
          clearUserData(dispatch);
          window.location.reload();
        }}
      >
        <Route>Logout</Route>
      </Clickable>
      <Clickable style={{ marginRight: "auto" }}>
        <Route to="/settings">Settings</Route>
      </Clickable>
      <Clickable style={{ marginRight: "auto" }}>
        <Route to="/faq" style={{ color: theme.MAIN_COLOR }}>
          Tutorial Page
        </Route>
      </Clickable>
      <Clickable style={{ marginRight: "auto" }} onClick={() => setBug(true)}>
        <ActionRoute style={{ color: theme.NEGATIVE }}>
          Report a Bug
        </ActionRoute>
      </Clickable>
      <Clickable style={{ marginRight: "auto" }}>
        <Route to="/privacy" style={{ color: theme.MAIN_COLOR }}>
          Privacy Policy
        </Route>
      </Clickable>
    </Drawer>
  );
};
export default NavigationDrawer;
